<header class="header-route">
  <img src="/assets/icons/arrow-left.svg" [alt]="'COMMONS.EXIT' | i18nextEager" (click)="cancel()" class="arrow" />
  <img src="/assets/icons/logo.svg" class="element" alt="{{ 'COMMONS.ACCIONA_LOGO' | i18nextEager }}" />
  <div class="container-title element">
    <h5>green energy</h5>
    <span class="separator"></span>
    <span class="subtitle">{{ 'HOME.NEW_CONTRACT' | i18nextEager | uppercase }}</span>
  </div>
  <div class="space"></div>
  <div *ngIf="hasContactoCRM && !noTypeSelected" class="nav">
    <div class="icon" [ngClass]="{ 'separator-icon': tabIndex !== 4, 'margin-right': tabIndex === 4 }">
      <img
        *ngIf="!haveIdDraft && tabIndex !== 4; else elseBlock"
        src="/assets/icons/delete.svg"
        [alt]="'HOME.CANCEL_CONTRACT' | i18nextEager"
      />
      <ng-template #elseBlock>
        <img
          src="/assets/icons/deleteRed.svg"
          [alt]="'HOME.CANCEL_CONTRACT' | i18nextEager"
          class="cursor-pointer"
          (click)="deleteContract()"
        />
      </ng-template>
    </div>
    <!-- <div class="separator-icon icon" [hidden]="tabIndex === 4">
      <img
        src="/assets/icons/download_red.svg"
        [alt]="'COMMONS.DOWNLOAD' | i18nextEager"
        class="cursor-pointer"
        (click)="clickDownload()"
      />
    </div> -->
    <div class="separator-icon icon" *ngIf="tabIndex < 4">
      <img
        src="/assets/icons/save_gray.svg"
        [alt]="'COMMONS.SAVE' | i18nextEager"
        *ngIf="!haveIdDraft; else elseBlockB"
      />
      <ng-template #elseBlockB>
        <img
          src="/assets/icons/save_red.svg"
          [alt]="'COMMONS.SAVE' | i18nextEager"
          class="cursor-pointer"
          (click)="clickSave()"
        />
      </ng-template>
    </div>
    <div *ngIf="showProgress" [ngClass]="{ 'margin-right': tabIndex === 4 }">
      <img
        [src]="'/assets/icons/progress-' + progress + '.svg'"
        [alt]="'COMMONS.PROGRESS' | i18nextEager"
        (click)="openDialog($event)"
        [ngClass]="{ 'cursor-pointer': tabIndex !== 0 }"
      />
    </div>
    <button (click)="next()" [disabled]="!activeNext.value" [hidden]="tabIndex === 4" class="margin-right">
      {{ 'COMMONS.NEXT' | i18nextEager }}
    </button>
  </div>
  <button
    *ngIf="hasContactoCRM && noTypeSelected"
    (click)="goToContract()"
    [disabled]="!activeNextCRM"
    class="margin-right"
  >
    {{ 'COMMONS.NEXT' | i18nextEager }}
  </button>
  <button *ngIf="!hasContactoCRM" (click)="goToContract()" [disabled]="!activeNextCRM" class="margin-right">
    {{ 'COMMONS.NEXT' | i18nextEager }}
  </button>
</header>
